// extracted by mini-css-extract-plugin
module.exports = {"table":"pIwjc","innerMessageWrapper":"_1MPwU","error":"_22wnl","notice":"_1NPcq"};